import * as stripe from './configStripe';
import * as listing from './configListing';
import * as search from './configSearch';
import * as maps from './configMaps';
import * as branding from './configBranding';
import * as layout from './configLayout';
import * as analytics from './configAnalytics';

import supportImage from '../assets/support1.png';
import supportImage2 from '../assets/support2.png';
import supportImage3 from '../assets/support3.png';


export const signupCountries = [
    { country: "Afghanistan", code: "AF", currency: "AFN" },
    { country: "Albania", code: "AL", currency: "ALL" },
    { country: "Algeria", code: "DZ", currency: "DZD" },
    { country: "Andorra", code: "AD", currency: "EUR" },
    { country: "Angola", code: "AO", currency: "AOA" },
    { country: "Antigua and Barbuda", code: "AG", currency: "XCD" },
    { country: "Argentina", code: "AR", currency: "ARS" },
    { country: "Armenia", code: "AM", currency: "AMD" },
    { country: "Australia", code: "AU", currency: "AUD" },
    { country: "Austria", code: "AT", currency: "EUR" },
    { country: "Azerbaijan", code: "AZ", currency: "AZN" },
    { country: "Bahamas", code: "BS", currency: "BSD" },
    { country: "Bahrain", code: "BH", currency: "BHD" },
    { country: "Bangladesh", code: "BD", currency: "BDT" },
    { country: "Barbados", code: "BB", currency: "BBD" },
    { country: "Belarus", code: "BY", currency: "BYN" },
    { country: "Belgium", code: "BE", currency: "EUR" },
    { country: "Belize", code: "BZ", currency: "BZD" },
    { country: "Benin", code: "BJ", currency: "XOF" },
    { country: "Bhutan", code: "BT", currency: "BTN" },
    { country: "Bolivia", code: "BO", currency: "BOB" },
    { country: "Bosnia and Herzegovina", code: "BA", currency: "BAM" },
    { country: "Botswana", code: "BW", currency: "BWP" },
    { country: "Brazil", code: "BR", currency: "BRL" },
    { country: "Brunei", code: "BN", currency: "BND" },
    { country: "Bulgaria", code: "BG", currency: "BGN" },
    { country: "Burkina Faso", code: "BF", currency: "XOF" },
    { country: "Burundi", code: "BI", currency: "BIF" },
    { country: "Cambodia", code: "KH", currency: "KHR" },
    { country: "Cameroon", code: "CM", currency: "XAF" },
    { country: "Canada", code: "CA", currency: "CAD" },
    { country: "Cape Verde", code: "CV", currency: "CVE" },
    { country: "Central African Republic", code: "CF", currency: "XAF" },
    { country: "Chad", code: "TD", currency: "XAF" },
    { country: "Chile", code: "CL", currency: "CLP" },
    { country: "Colombia", code: "CO", currency: "COP" },
    { country: "Comoros", code: "KM", currency: "KMF" },
    { country: "Congo (Brazzaville)", code: "CG", currency: "XAF" },
    { country: "Congo (Kinshasa)", code: "CD", currency: "CDF" },
    { country: "Costa Rica", code: "CR", currency: "CRC" },
    { country: "Croatia", code: "HR", currency: "HRK" },
    { country: "Cyprus", code: "CY", currency: "EUR" },
    { country: "Czech Republic", code: "CZ", currency: "CZK" },
    { country: "Denmark", code: "DK", currency: "DKK" },
    { country: "Djibouti", code: "DJ", currency: "DJF" },
    { country: "Dominica", code: "DM", currency: "XCD" },
    { country: "Dominican Republic", code: "DO", currency: "DOP" },
    { country: "East Timor", code: "TL", currency: "USD" },
    { country: "Ecuador", code: "EC", currency: "USD" },
    { country: "Egypt", code: "EG", currency: "EGP" },
    { country: "El Salvador", code: "SV", currency: "USD" },
    { country: "Equatorial Guinea", code: "GQ", currency: "XAF" },
    { country: "Eritrea", code: "ER", currency: "ERN" },
    { country: "Estonia", code: "EE", currency: "EUR" },
    { country: "Eswatini", code: "SZ", currency: "SZL" },
    { country: "Ethiopia", code: "ET", currency: "ETB" },
    { country: "Fiji", code: "FJ", currency: "FJD" },
    { country: "Finland", code: "FI", currency: "EUR" },
    { country: "France", code: "FR", currency: "EUR" },
    { country: "Gabon", code: "GA", currency: "XAF" },
    { country: "Gambia", code: "GM", currency: "GMD" },
    { country: "Georgia", code: "GE", currency: "GEL" },
    { country: "Germany", code: "DE", currency: "EUR" },
    { country: "Ghana", code: "GH", currency: "GHS" },
    { country: "Greece", code: "GR", currency: "EUR" },
    { country: "Grenada", code: "GD", currency: "XCD" },
    { country: "Guatemala", code: "GT", currency: "GTQ" },
    { country: "Guinea", code: "GN", currency: "GNF" },
    { country: "Guinea-Bissau", code: "GW", currency: "XOF" },
    { country: "Guyana", code: "GY", currency: "GYD" },
    { country: "Haiti", code: "HT", currency: "HTG" },
    { country: "Honduras", code: "HN", currency: "HNL" },
    { country: "Hungary", code: "HU", currency: "HUF" },
    { country: "Iceland", code: "IS", currency: "ISK" },
    { country: "India", code: "IN", currency: "INR" },
    { country: "Indonesia", code: "ID", currency: "IDR" },
    { country: "Iran", code: "IR", currency: "IRR" },
    { country: "Iraq", code: "IQ", currency: "IQD" },
    { country: "Ireland", code: "IE", currency: "EUR" },
    { country: "Israel", code: "IL", currency: "ILS" },
    { country: "Italy", code: "IT", currency: "EUR" },
    { country: "Jamaica", code: "JM", currency: "JMD" },
    { country: "Japan", code: "JP", currency: "JPY" },
    { country: "Jordan", code: "JO", currency: "JOD" },
    { country: "Kazakhstan", code: "KZ", currency: "KZT" },
    { country: "Kenya", code: "KE", currency: "KES" },
    { country: "Kiribati", code: "KI", currency: "AUD" },
    { country: "Korea (North)", code: "KP", currency: "KPW" },
    { country: "Korea (South)", code: "KR", currency: "KRW" },
    { country: "Kosovo", code: "XK", currency: "EUR" },
    { country: "Kuwait", code: "KW", currency: "KWD" },
    { country: "Kyrgyzstan", code: "KG", currency: "KGS" },
    { country: "Laos", code: "LA", currency: "LAK" },
    { country: "Latvia", code: "LV", currency: "EUR" },
    { country: "Lebanon", code: "LB", currency: "LBP" },
    { country: "Lesotho", code: "LS", currency: "LSL" },
    { country: "Liberia", code: "LR", currency: "LRD" },
    { country: "Libya", code: "LY", currency: "LYD" },
    { country: "Liechtenstein", code: "LI", currency: "CHF" },
    { country: "Lithuania", code: "LT", currency: "EUR" },
    { country: "Luxembourg", code: "LU", currency: "EUR" },
    { country: "Madagascar", code: "MG", currency: "MGA" },
    { country: "Malawi", code: "MW", currency: "MWK" },
    { country: "Malaysia", code: "MY", currency: "MYR" },
    { country: "Maldives", code: "MV", currency: "MVR" },
    { country: "Mali", code: "ML", currency: "XOF" },
    { country: "Malta", code: "MT", currency: "EUR" },
    { country: "Marshall Islands", code: "MH", currency: "USD" },
    { country: "Mauritania", code: "MR", currency: "MRU" },
    { country: "Mauritius", code: "MU", currency: "MUR" },
    { country: "Mexico", code: "MX", currency: "MXN" },
    { country: "Micronesia", code: "FM", currency: "USD" },
    { country: "Moldova", code: "MD", currency: "MDL" },
    { country: "Monaco", code: "MC", currency: "EUR" },
    { country: "Mongolia", code: "MN", currency: "MNT" },
    { country: "Montenegro", code: "ME", currency: "EUR" },
    { country: "Morocco", code: "MA", currency: "MAD" },
    { country: "Mozambique", code: "MZ", currency: "MZN" },
    { country: "Myanmar", code: "MM", currency: "MMK" },
    { country: "Namibia", code: "NA", currency: "NAD" },
    { country: "Nauru", code: "NR", currency: "AUD" },
    { country: "Nepal", code: "NP", currency: "NPR" },
    { country: "Netherlands", code: "NL", currency: "EUR" },
    { country: "New Zealand", code: "NZ", currency: "NZD" },
    { country: "Nicaragua", code: "NI", currency: "NIO" },
    { country: "Niger", code: "NE", currency: "XOF" },
    { country: "Nigeria", code: "NG", currency: "NGN" },
    { country: "North Macedonia", code: "MK", currency: "MKD" },
    { country: "Norway", code: "NO", currency: "NOK" },
    { country: "Oman", code: "OM", currency: "OMR" },
    { country: "Pakistan", code: "PK", currency: "PKR" },
    { country: "Palau", code: "PW", currency: "USD" },
    { country: "Palestine", code: "PS", currency: "ILS" },
    { country: "Panama", code: "PA", currency: "PAB" },
    { country: "Papua New Guinea", code: "PG", currency: "PGK" },
    { country: "Paraguay", code: "PY", currency: "PYG" },
    { country: "Peru", code: "PE", currency: "PEN" },
    { country: "Philippines", code: "PH", currency: "PHP" },
    { country: "Poland", code: "PL", currency: "PLN" },
    { country: "Portugal", code: "PT", currency: "EUR" },
    { country: "Qatar", code: "QA", currency: "QAR" },
    { country: "Romania", code: "RO", currency: "RON" },
    { country: "Rwanda", code: "RW", currency: "RWF" },
    { country: "Saint Kitts and Nevis", code: "KN", currency: "XCD" },
    { country: "Saint Lucia", code: "LC", currency: "XCD" },
    { country: "Saint Vincent and the Grenadines", code: "VC", currency: "XCD" },
    { country: "Samoa", code: "WS", currency: "WST" },
    { country: "San Marino", code: "SM", currency: "EUR" },
    { country: "Sao Tome and Principe", code: "ST", currency: "STD" },
    { country: "Saudi Arabia", code: "SA", currency: "SAR" },
    { country: "Senegal", code: "SN", currency: "XOF" },
    { country: "Serbia", code: "RS", currency: "RSD" },
    { country: "Seychelles", code: "SC", currency: "SCR" },
    { country: "Sierra Leone", code: "SL", currency: "SLL" },
    { country: "Singapore", code: "SG", currency: "SGD" },
    { country: "Slovakia", code: "SK", currency: "EUR" },
    { country: "Slovenia", code: "SI", currency: "EUR" },
    { country: "Solomon Islands", code: "SB", currency: "SBD" },
    { country: "Somalia", code: "SO", currency: "SOS" },
    { country: "South Africa", code: "ZA", currency: "ZAR" },
    { country: "South Sudan", code: "SS", currency: "SSP" },
    { country: "Spain", code: "ES", currency: "EUR" },
    { country: "Sri Lanka", code: "LK", currency: "LKR" },
    { country: "Sudan", code: "SD", currency: "SDG" },
    { country: "Suriname", code: "SR", currency: "SRD" },
    { country: "Sweden", code: "SE", currency: "SEK" },
    { country: "Switzerland", code: "CH", currency: "CHF" },
    { country: "Syria", code: "SY", currency: "SYP" },
    { country: "Taiwan", code: "TW", currency: "TWD" },
    { country: "Tajikistan", code: "TJ", currency: "TJS" },
    { country: "Tanzania", code: "TZ", currency: "TZS" },
    { country: "Thailand", code: "TH", currency: "THB" },
    { country: "Togo", code: "TG", currency: "XOF" },
    { country: "Tonga", code: "TO", currency: "TOP" },
    { country: "Trinidad and Tobago", code: "TT", currency: "TTD" },
    { country: "Tunisia", code: "TN", currency: "TND" },
    { country: "Turkey", code: "TR", currency: "TRY" },
    { country: "Turkmenistan", code: "TM", currency: "TMT" },
    { country: "Tuvalu", code: "TV", currency: "AUD" },
    { country: "Uganda", code: "UG", currency: "UGX" },
    { country: "Ukraine", code: "UA", currency: "UAH" },
    { country: "United Arab Emirates", code: "AE", currency: "AED" },
    { country: "United Kingdom", code: "GB", currency: "GBP" },
    { country: "United States", code: "US", currency: "USD" },
    { country: "Uruguay", code: "UY", currency: "UYU" },
    { country: "Uzbekistan", code: "UZ", currency: "UZS" },
    { country: "Vanuatu", code: "VU", currency: "VUV" },
    { country: "Venezuela", code: "VE", currency: "VES" },
    { country: "Vietnam", code: "VN", currency: "VND" },
    { country: "Yemen", code: "YE", currency: "YER" },
    { country: "Zambia", code: "ZM", currency: "ZMW" },
    { country: "Zimbabwe", code: "ZW", currency: "ZWL" }
];

export const algoliaListingFacets = [
    'publicData.category',
    'publicData.access_to_rentals',
    'publicData.Condition_of_the_item',
    'publicData.Trust_and_verification',
    'publicData.cancelation_policy',
    'publicData.reason_for_listing',
    'publicData.security_deposit',
    'price.amount'
];

const quickGuides = [
    {
        image: supportImage,
        title: 'How I Made Over $250,000 Renting 3 Barbecues: The Power of Quality Investment',
        time: '5 min read',
        url: 'https://www.rentanythingstore.com/page/how_i_earned_over_250k_with_3_bbqs',
    },
    {
        image: supportImage2,
        title: 'Why People Rent Instead of Buy: Exploring Rental Demand',
        time: '5 min read',
        url: 'https://www.rentanythingstore.com/page/reasons_why_people_would_rent_your_stuff',
    },
    {
        image: supportImage3,
        title: 'Boost Profits with Niche Rental Stores: How Specialization on RentAnythingStore Can Transform Your Business',
        time: '5 min read',
        url: 'https://www.rentanythingstore.com/page/advantages_of_creating_niche_rental_stores',
    },
];

const faqs = [
    // RentAnything Wizard Listing Process
    {
        question: 'What is the RentAnything Wizard and how does it work?',
        answer: 'The RentAnything Wizard—powered by ConductorStudio.ai—helps you create professional, optimized listings in seconds. Upload a photo or type a few words, and the Wizard generates a title, description, pricing, tags, FAQs, images, and even blog content.',
    },
    {
        question: 'What are the benefits of using the RentAnything Wizard?',
        answer: 'The Wizard is designed to boost your visibility through SEO (Search Engine Optimization) and AIO (AI Optimization). Listings are more likely to show up on Google and internal search, and include rich content that builds trust and encourages bookings.',
    },
    {
        question: 'Do I have to use the RentAnything Wizard?',
        answer: 'Yes. All listings must be created through the Wizard, but you have full control to edit every detail before publishing.',
    },
    {
        question: 'What types of items can I list?',
        answer: 'You can list almost anything people want to rent—tools, baby gear, electronics, camping gear, party supplies, photo and film equipment, mobility aids, furniture, and more.',
    },
    {
        question: 'Can I do bulk uploads of my inventory?',
        answer: 'Not directly, but if you have multiple items, contact us and we\'ll assist with a batch listing setup.',
    },
    // Fees & Payouts
    {
        question: 'How much does it cost to list an item?',
        answer: 'It\'s free to list any item on RentAnythingStore.com.',
    },
    {
        question: 'What fees does RentAnythingStore.com charge?',
        answer: 'We take a maximum of 20% commission on completed rentals. That percentage may decrease depending on the value of your items and how often they\'re rented.',
    },
    {
        question: 'How do I get paid?',
        answer: 'Payouts are processed via Stripe. You\'ll see your expected payout when a booking is confirmed. Funds are released after the rental ends.',
    },
    {
        question: 'How long does it take to receive the payout?',
        answer: 'Stripe typically transfers funds to your bank account within 3–5 business days after the rental period ends.',
    },
    // Owner's Protection & Platform Safety
    {
        question: 'What happens if my item gets damaged or stolen?',
        answer: 'Our Owner\'s Protection Program covers eligible theft or damage. Learn more in our protection program documentation.',
    },
    {
        question: 'Is the platform safe?',
        answer: 'Yes. We verify all users, actively monitor listings, and use a review system to build trust and accountability.',
    },
    {
        question: 'Can I read reviews before renting or accepting a booking?',
        answer: 'Yes. Both renters and owners leave reviews after transactions—giving you insight before confirming any rental.',
    },
    // Uploading & Listing Enhancements
    {
        question: 'Can the Wizard generate images for me?',
        answer: 'Yes! If you don\'t upload your own photos, the Wizard can generate clean, branded preview images based on your item type and description.',
    },
    {
        question: 'What kind of photos should I use?',
        answer: 'For best results, upload 7–12 high-quality, well-lit photos showing different angles and (if possible) the item in use.',
    },
    {
        question: 'Does the Wizard write the title and description?',
        answer: 'Yes. The RentAnything Wizard creates a compelling, optimized title and description—but you can customize it however you like.',
    },
    {
        question: 'Will the Wizard add tags and keywords?',
        answer: 'Yes. It includes optimized tags and alternate internal search descriptions to improve discoverability.',
    },
    {
        question: 'Will it suggest FAQs for my listing?',
        answer: 'Yes. The Wizard automatically generates listing-specific FAQs, which help improve SEO, educate renters, and build trust.',
    },
    {
        question: 'Will the Wizard create a blog post for my listing?',
        answer: 'Yes. If your item has sufficient value, the Wizard creates a mini blog post shown at the bottom of your listing. This improves both search ranking and customer engagement.',
    },
    // Pricing & Optimization
    {
        question: 'Does the Wizard suggest pricing?',
        answer: 'Yes. It recommends daily, 2-day, weekly, and monthly rates based on similar listings and local demand.',
    },
    {
        question: 'Can I set my own prices?',
        answer: 'Yes. You\'re in complete control of all pricing details.',
    },
    {
        question: 'What if my item is rare or highly specialized?',
        answer: 'The Wizard still gives you a strong starting point, and you can fine-tune as needed.',
    },
    // Support & Coaching
    {
        question: 'What if something goes wrong with my listing or booking?',
        answer: 'You can always reach out to our support team for troubleshooting help—we\'re here to assist.',
    },
    {
        question: 'Do you offer rental coaching or advice?',
        answer: 'Yes! We offer a complimentary rental coaching session to help you get started or grow your rental business. Book your rental coach through our support portal.',
    },
    {
        question: 'Can I create a listing manually instead of using the Wizard?',
        answer: 'No. All listings must be created using the RentAnything Wizard to ensure they meet our platform standards—but you can edit every part of your listing once it\'s generated.',
    },
    {
        question: 'What if I\'m listing a large number of items?',
        answer: 'Reach out to us for bulk listing support—we\'re happy to help you scale.',
    },
    // Advanced & Power Users
    {
        question: 'Does the Wizard support niche items like photography gear or construction equipment?',
        answer: 'Yes. The Wizard is designed to handle a wide range of item types and categories.',
    },
    {
        question: 'Will the Wizard improve over time?',
        answer: 'Absolutely. It gets smarter with use—improving accuracy, optimization, and overall listing quality.',
    },
    // Tools to Help You Succeed
    {
        question: 'What is the Rental Evaluator?',
        answer: 'This free tool helps you determine an item\'s earning potential, best season to rent, and effective marketing tips.',
    },
    {
        question: 'Can I create a branded rental store?',
        answer: 'Yes! Build your own branded storefront, promote it directly, and still benefit from being listed in the RentAnythingStore.com marketplace.',
    },
    {
        question: 'Can I charge for extras like delivery or cleaning?',
        answer: 'Yes. You can add fees for delivery, pickup, setup, fuel, or cleaning—whatever fits your business.',
    },
];


// NOTE: only expose configuration that should be visible in the
// client side, don't add any server secrets to this file.
const defaultConfig = {
    // Marketplace root url is the root or domain, where this app is currently running
    // It is needed in social media sharing and SEO optimization purposes and SSO etc.
    // It should be in environment variables (on localhost 'yarn run config' or edit .env file)
    marketplaceRootURL: process.env.REACT_APP_MARKETPLACE_ROOT_URL,

    // Marketplace currency.
    // The currency used in the Marketplace must be in ISO 4217 currency code. For example USD, EUR, CAD, AUD, etc. The default value is USD.
    // It should match one of the currencies listed in currencySettings.js
    // Note: The currency comes from localization asset nowadays by default.
    //       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeCurrency func)
    currency: 'CAD',

    defaultLocation: {
        latLng: [45.412836, -75.704551],
        country: 'Canada',
        countryCode: 'CA',
        city: 'Ottawa'
    },

    // Listing minimum price in currency sub units, e.g. cents.
    // 0 means no restriction to the price
    // Note 1: The listingMinimumPriceSubUnits comes from transactionSize asset nowadays by default.
    //         To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeConfig func)
    // Note 2: Stripe does have minimum fee that depends on country, currency, etc.
    //         We allow 10 cents minimum, but Stripe may require higher amounts (typically $0.50 USD).
    //         Users will see an error message if their transaction total is below Stripe's minimum.
    listingMinimumPriceSubUnits: 10,

    // Marketplace name is needed for microcopy (aka marketplace texts) and in meta tags (bots and social media sharing reads those)
    marketplaceName: process.env.REACT_APP_MARKETPLACE_NAME || 'Biketribe',

    // Modify Stripe configuration in configStripe.js
    // - picks REACT_APP_STRIPE_PUBLISHABLE_KEY from environment variables
    // - dayCountAvailableForBooking: Stripe can hold payments only limited time on Connect Account
    //                                This adds some restriction for bookings (payouts vs long bookings)
    // - defaultMCC: sets Default Merchant Category Code
    // - supportedCountries
    stripe,

    signupCountries,
    // Modify listing extended data and listing type in configListing.js
    listing,
    // Modify search settings data in configSearch.js
    search,
    // Modify settings for map providers in configMaps.js
    // This includes also default locations for location search
    maps,
    // Modify branding configs in configBranding.js
    branding,
    // Modify layout configs in configLayout.js
    layout,
    // Modify analytics configs in configAnalytics.js
    // By default, it doesn't add anything.
    analytics,

    // Note: Facebook app id is used for Facebook login, but it is also used for tracking:
    // Facebook counts shares with app or page associated by this id
    // Currently it is unset, but you can read more about fb:app_id from
    // https://developers.facebook.com/docs/sharing/webmasters#basic
    // You should create one to track social sharing in Facebook
    facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,

    // If you want to change the language, remember to also change the
    // locale data and the messages in the app.js file.
    // Note: The localization comes from localization asset nowadays by default.
    //       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeLocalizations func)
    localization: {
        locale: 'en-US',
        // First day of week
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo#return_value
        // 1: Monday
        // ...
        // 6: Saturday
        // 7: Sunday
        firstDayOfWeek: 1,
    },

    // CDN assets for the app. Configurable through Sharetribe Console.
    // Note 1: The path must match the path defined in Asset Delivery API
    // Note 2: If you customize the app and rely on custom code instead of a config assets,
    //         you should remove the unnecessary config asset from this list.
    appCdnAssets: {
        translations: '/content/translations.json',
        footer: '/content/footer.json',
        topbar: '/content/top-bar.json',
        branding: '/design/branding.json',
        layout: '/design/layout.json',
        listingTypes: '/listings/listing-types.json',
        listingFields: '/listings/listing-fields.json',
        search: '/listings/listing-search.json',
        transactionSize: '/transactions/minimum-transaction-size.json',
        analytics: '/integrations/analytics.json',
        googleSearchConsole: '/integrations/google-search-console.json',
        maps: '/integrations/map.json',
        // These assets are not yet editable through Console.
        // However, Sharetribe onboarding might generate them.
        // You could still rely on built-in variables and comment these out.
        localization: '/general/localization.json',
        // NOTE: we don't fetch commission configuration here but on the server-side
    },

    // Optional
    // Online presence of the same organization:
    // Facebook page is used in SEO schema (http://schema.org/Organization)
    siteFacebookPage: null, // e.g. '@sharetribe',
    // Instagram page is used in SEO schema (http://schema.org/Organization)
    siteInstagramPage: null, // e.g. 'https://www.instagram.com/sharetribe/',
    // Twitter handle is needed in meta tags (twitter:site). Start it with '@' character
    siteTwitterHandle: null, // e.g. 'https://www.facebook.com/Sharetribe/',

    // Optional
    // This creates meta tag for Google Search Console verification
    // I.e. <meta name=“google-site-verification” content=“GOOGLE_SITE_VERIFICATION_TOKEN”/>
    // Note: The googleSearchConsole comes from googleSearchConsole asset nowadays by default.
    //       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeConfig func)
    googleSearchConsole: {
        googleSiteVerification: null, // Add google-site-verification token as a string
    },

    // Optional
    // Address information is used in SEO schema for Organization (http://schema.org/PostalAddress)
    // Note: Google doesn't recognize this:
    // https://developers.google.com/search/docs/advanced/structured-data/logo#structured-data-type-definitions
    address: {
        addressCountry: null, // 'FI',
        addressRegion: null, // 'Helsinki',
        postalCode: null, // '00130',
        streetAddress: null, // 'Erottajankatu 19 B',
    },
    quickGuides,
    faqs,
};

export default defaultConfig;
